import { CreatePaylink, DeletePaylink } from "utils/URLs";
import { post, get } from "utils/v2/api";

export const createPaylinkAPI = (data: any) => post(`${CreatePaylink}`, data);
export const getPaylinkAPI = () => get(`${CreatePaylink}`);
export const deletePaylinkAPI = (data:any) => post(`${DeletePaylink}`,data);